import React, { useMemo } from "react";
import '../styles/ProductList.css';

const getCategoryColor = (category) => {
  const hue = [...category].reduce((acc, char) => acc + char.charCodeAt(0), 0) % 360;
  return `hsl(${hue}, 70%, 60%)`;
};

const getContrastColor = (hexColor) => {
  if (hexColor.startsWith('hsl')) {
    const values = hexColor.match(/\d+/g);
    const lightness = parseInt(values[2]);
    return lightness > 50 ? '#000000' : '#ffffff';
  }
  return '#000000';
};

const ProductList = ({ group, category, products, onSelectProduct, onBack }) => {
  const productsInGroup = useMemo(() => {
    return products.filter(
      (product) => product.group === group && product.category === category
    );
  }, [products, group, category]);

  return (
    <div className="product-list">
      <div className="breadcrumb">
        <button className="nav-button" onClick={onBack}>
          ← Volver a Categorías
        </button>
        <span className="breadcrumb-separator">/</span>
        <span>{category} - {group}</span>
      </div>

      <div className="grid-container">
        {productsInGroup.map((product) => {
          const categoryColor = getCategoryColor(category);
          const productInitial = product.name.charAt(0).toUpperCase();

          return (
            <div
              key={product.id}
              className="grid-item product-item"
              onClick={() => {
                // ESTA ES LA LÍNEA CRÍTICA QUE DEBE FUNCIONAR
                console.log("🛒 Producto clickeado, llamando a onSelectProduct:", product);
                if (onSelectProduct && typeof onSelectProduct === 'function') {
                  onSelectProduct(product);
                } else {
                  console.error("❌ onSelectProduct no es una función válida");
                }
              }}
            >
              <div
                className="product-initial"
                style={{
                  backgroundColor: categoryColor,
                  color: getContrastColor(categoryColor),
                }}
              >
                {productInitial}
              </div>
              <h3>{product.name}</h3>
              <p>${product.price.toFixed(2)}</p>
              {product.stock !== undefined && (
                <div
                  className={`stock-indicator ${
                    product.stock > 0 ? 'available' : 'out-of-stock'
                  }`}
                >
                  {product.stock > 0 ? 'Disponible' : 'Agotado'}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductList;